import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addRoomFailure,
  //
  addRoomSuccess,
  addSlickCareProfilesFailure,
  //
  addSlickCareProfilesSuccess,
  deleteCareRoomFailure,
  //
  deleteCareRoomSuccess,
  deleteSlickCareProfilesFailure,
  //
  deleteSlickCareProfilesSuccess,
  editCareRoomFailure,
  editCareRoomSuccess,
  editSlickCareProfilesFailure,
  //
  editSlickCareProfilesSuccess,
  fetchAllLocationFailure,
  //
  fetchAllLocationSuccess,
  //
  fetchAllRooms,
  fetchAllRoomsFailure,
  fetchAllRoomsSuccess,
  fetchRoomsFailure,
  //
  fetchRoomsSuccess,
  fetchSlickCareProfilesFailure,
  fetchSlickCareProfilesSuccess,
  //
  getCareRoomData,
  getCareRoomDataFailure,
  //
  getCareRoomDataSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  inviteStaffFailure,
  //
  inviteStaffSuccess,
  //
  searchSlickCareProfiles as searchSlickCareProfilesAction,
  searchSlickCareProfilesFailure,
  searchSlickCareProfilesSuccess,
  //
  searchCompanySuccess,
  searchCompanyFailure,
  //
  changeCompanySuccess,
  changeCompanyFailure,
} from "./actions";
import {
  ADD_ROOM,
  ADD_SLICK_CARE_PROFILES,
  DELETE_CARE_ROOM,
  DELETE_SLICK_CARE_PROFILES,
  EDIT_CARE_ROOM,
  EDIT_SLICK_CARE_PROFILES,
  FETCH_ALL_LOCATION,
  FETCH_ALL_ROOMS,
  FETCH_ROOMS,
  FETCH_SLICK_CARE_PROFILES,
  GET_CARE_ROOM_DATA,
  GET_VIEW_DATA,
  INVITE_STAFF,
  SEARCH_SLICK_CARE_PROFILES,
  SEARCH_COMPANY,
  CHANGE_COMPANY,
} from "./constants";

export function* fetchSlickCareProfilesSaga({
  payload = { cancelToken: null },
}) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location?${query}`);
    yield put(fetchSlickCareProfilesSuccess(data));
  } catch (e) {
    yield put(fetchSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching locations!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addSlickCareProfilesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/location/add`, payload.data);
    if (data) {
      yield put(successAlert("Location added successfully!"));
      yield put(addSlickCareProfilesSuccess());
      if (payload?.history) {
        payload.history.push(
          `/d/company/edit/${data?.data?.company_id}/locations`
        );
      }
    }
  } catch (e) {
    yield put(addSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editSlickCareProfilesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/location/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Location updated successfully!"));
      yield put(editSlickCareProfilesSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteSlickCareProfilesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/location/${payload?.id}`);
    if (data) {
      yield put(successAlert("Location deleted successfully!"));
      yield put(deleteSlickCareProfilesSuccess());
      yield put(
        searchSlickCareProfilesAction({
          page: 1,
          limit: 10,
          company_id: payload.company_id,
        })
      );
    }
  } catch (e) {
    yield put(deleteSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchSlickCareProfilesSaga({
  payload = { cancelToken: null },
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location?${query}`);
    yield put(searchSlickCareProfilesSuccess(data));
  } catch (e) {
    yield put(searchSlickCareProfilesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching Location!"));
  }
}

export function* fetchAllLocationSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/location?${query}`);
    yield put(fetchAllLocationSuccess(data));
  } catch (e) {
    yield put(fetchAllLocationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching Locations!"));
  }
}

export function* addRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/care-room-types/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Room(s) added successfully!"));
      yield put(addRoomSuccess());
      yield put(getViewDataAction(payload.data.location_id));
    }
  } catch (e) {
    yield put(addRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchRoomsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/type-of-room-and-count?${query}`
    );
    yield put(fetchRoomsSuccess(data));
  } catch (e) {
    yield put(fetchRoomsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching rooms!"));
  }
}

export function* fetchAllRoomsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/care-room?${query}`);
    yield put(fetchAllRoomsSuccess(data));
  } catch (e) {
    yield put(fetchAllRoomsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching rooms!"));
  }
}

export function* deleteCareRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/care-room/delete`, payload);
    if (data) {
      yield put(successAlert("Room deleted successfully!"));
      yield put(deleteCareRoomSuccess());
      yield put(
        fetchAllRooms({ page: 1, limit: 10, location_id: payload.location_id })
      );
    }
  } catch (e) {
    yield put(deleteCareRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getCareRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/care-room/${payload}`);
    yield put(getCareRoomDataSuccess(data));
  } catch (e) {
    yield put(getCareRoomDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching care room!"));
  }
}

export function* editCareRoomSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/care-room/edit/${payload?.data?.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Room updated successfully!"));
      yield put(editCareRoomSuccess());
      yield put(getCareRoomData(payload?.data?.id));
    }
  } catch (e) {
    yield put(editCareRoomFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* inviteStaffSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/invite-staff-mail`, payload);
    if (data) {
      yield put(successAlert("Invite sent successfully!"));
      yield put(inviteStaffSuccess());
    }
  } catch (e) {
    yield put(inviteStaffFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while sending invite!"));
  }
}

export function* searchCompanySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";

  try {
    const data = yield call(api(token).get, `/api/company-search?${query}`);
    if (data) {
      yield put(searchCompanySuccess(data));
    }
  } catch (e) {
    yield put(searchCompanyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching!"));
  }
}

export function* changeChangeSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/changes-company-location/${payload.id}`,
      payload?.data
    );
    if (data) {
      yield put(changeCompanySuccess(data));
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(changeCompanyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while searching!"));
  }
}

export function* fetchSlickCareProfilesFlow() {
  yield takeEvery(FETCH_SLICK_CARE_PROFILES, fetchSlickCareProfilesSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addSlickCareProfilesFlow() {
  yield takeEvery(ADD_SLICK_CARE_PROFILES, addSlickCareProfilesSaga);
}
export function* editSlickCareProfilesFlow() {
  yield takeEvery(EDIT_SLICK_CARE_PROFILES, editSlickCareProfilesSaga);
}
export function* deleteSlickCareProfilesFlow() {
  yield takeEvery(DELETE_SLICK_CARE_PROFILES, deleteSlickCareProfilesSaga);
}
export function* searchSlickCareProfilesFlow() {
  yield takeEvery(SEARCH_SLICK_CARE_PROFILES, searchSlickCareProfilesSaga);
}
export function* addRoomFlow() {
  yield takeEvery(ADD_ROOM, addRoomSaga);
}
export function* fetchRoomsFlow() {
  yield takeEvery(FETCH_ROOMS, fetchRoomsSaga);
}
export function* fetchAllLocationFlow() {
  yield takeEvery(FETCH_ALL_LOCATION, fetchAllLocationSaga);
}
export function* fetchAllRoomsFlow() {
  yield takeEvery(FETCH_ALL_ROOMS, fetchAllRoomsSaga);
}
export function* deleteCareRoomFlow() {
  yield takeEvery(DELETE_CARE_ROOM, deleteCareRoomSaga);
}
export function* getCareRoomFlow() {
  yield takeEvery(GET_CARE_ROOM_DATA, getCareRoomSaga);
}
export function* editCareRoomFlow() {
  yield takeEvery(EDIT_CARE_ROOM, editCareRoomSaga);
}
export function* inviteStaffFlow() {
  yield takeEvery(INVITE_STAFF, inviteStaffSaga);
}
export function* searchCompanyFlow() {
  yield takeEvery(SEARCH_COMPANY, searchCompanySaga);
}
export function* changeChangeFlow() {
  yield takeEvery(CHANGE_COMPANY, changeChangeSaga);
}

export default function* SlickCareProfilesSaga() {
  yield all([
    fetchSlickCareProfilesFlow(),
    addSlickCareProfilesFlow(),
    editSlickCareProfilesFlow(),
    deleteSlickCareProfilesFlow(),
    getViewDataFlow(),
    searchSlickCareProfilesFlow(),
    addRoomFlow(),
    fetchRoomsFlow(),
    fetchAllLocationFlow(),
    fetchAllRoomsFlow(),
    deleteCareRoomFlow(),
    getCareRoomFlow(),
    editCareRoomFlow(),
    inviteStaffFlow(),
    searchCompanyFlow(),
    changeChangeFlow(),
  ]);
}
